import React from 'react'
import {Suspense} from 'react'
import {withRouter} from 'react-router-dom';
const Inspection = React.lazy(() => import("../pages/inspection/index"));



class ContentRouter extends React.Component{
    shouldComponentUpdate() {
        if(localStorage.getItem('permissions') && JSON.parse(localStorage.getItem('permissions')).length === 0){
            return false
        }else{
            return true
        }
    }
    render () {
        return (
            <Suspense  fallback={<div>Loading...</div>}>
                <Inspection/>
            </Suspense>
        )
    }
};
export default (withRouter(ContentRouter))
